<template>
  <div id="acaIndex">
    <bread :content="breadContent"></bread>
    <p class="Page-title">研究动态</p>
    <el-divider></el-divider>
    <div id="content">
      <div id="left">
        <news-card v-for="(item, index) in showTable" :key="index" :data="item"></news-card>
        <el-pagination class="page" background layout="prev, pager, next,jumper" :total="newsData.length" :page-size="9" @current-change="handleCurrentChange" :current-page="tableIndex">
        </el-pagination>
      </div>
      <timeline :list="timelineData.list" :iconSrc="timelineData.iconSrc" :title="'最新热点'" :titleColor="'red'"></timeline>
    </div>
  </div>
</template>
<script>
import bread from "@/components/bread";
import newsCard from "@/components/academic/newsCard";
import timeline from "@/components/timeline";
import Api from "@/network.js";
export default {
  name: "acaIndex",
  components: {
    bread,
    newsCard,
    timeline
  },
  async beforeRouteEnter(from, to, next) {
    let resTimeData = await Api.index.getLast("yjdt");
    let res = (await Api.academic.getTrends()) || [];
    next(async vm => {
      vm.newsData = res;
      vm.showTable = vm.newsData.slice(0, 9);
      for (let item of resTimeData) {
        vm.timelineData.list.push({
          date: item.Date,
          content: item.Title,
          url: `/academic/trends/detail?id=${encodeURIComponent(item.Id)}`
        });
      }
    });
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "学术交流", routerName: "academic" },
        { text: "研究动态", routerName: "academic" }
      ],
      newsData: [],
      timelineData: {
        title: "最新热点",
        iconSrc: require("../../assets/fire-icon.png"),
        list: []
      },
      showTable: [],
      tableIndex: 1
    };
  },
  methods: {
    handleCurrentChange(index) {
      this.showTable = this.newsData.slice((index - 1) * 9, index * 9);
    }
  }
};
</script>
  
<style lang="scss" scoped>
#acaIndex {
  display: block;
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
  #content {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  #left {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% - 260px);
    .newsCard {
      width: calc((100% - 250px)/3);
      margin: 10px;
    }
    @media screen and(max-width: 1500px) {
      .newsCard {
        width: calc(50% - 80px);
      }
    }
  }
}
.page {
  width: 100%;
  transform: scale(1.3);
  text-align: center;
  margin-top: 50px;
}
</style>


